import type { FileUploadState } from '../app/components/file-upload.tsx';
import baseApi from './meeting-md-api-slice';

const fileUploadApiSlice = baseApi.injectEndpoints({
  endpoints: builder => ({
    postFile: builder.mutation<FileUploadState, File>({
      query: file => {
        const bodyForm = new FormData();
        bodyForm.append('file', file);
        return {
          url: 'File/Upload',
          method: 'POST',
          body: bodyForm,
          formData: true,
        };
      },
      transformResponse: (response: { url: string; blob: string }, _meta: any) => {
        return {
          url: response.url,
          file: response.blob,
          loading: false,
        } as FileUploadState;
      },
    }),
    deleteFile: builder.mutation<FileUploadState, FileUploadState>({
      query: obj => ({
        url: `File/${obj.url}`,
        method: 'DELETE',
      }),
      transformResponse: (_response: unknown, _meta: any, arg: FileUploadState) => {
        return {
          url: arg.url,
          file: arg.file,
          loading: false,
        } as FileUploadState;
      },
    }),
    fetchFileUrl: builder.query<string, string>({
      query: url => ({
        url: `File/${url}`,
      }),
      transformResponse: async (_response: { blob: string }, _meta: any) => {
        return _response?.blob;
      },
    }),
  }),
});

export const { usePostFileMutation, useDeleteFileMutation, useFetchFileUrlQuery } =
  fileUploadApiSlice;
